import Chart from "chart.js/auto";

class TouchitChart {
  constructor(canvas) {
    this.chartRoot = canvas;
    this.canvas = canvas.getContext("2d");
    this.type = canvas.dataset.type;
    this.gradient = this.canvas.createLinearGradient(0, 0, 0, 400);

    this.gradient.addColorStop(0, "#d93834"); // start
    this.gradient.addColorStop(1, "#E67572"); // end

    this.renderChart();
  }

  collectCoordinates(data) {
    if (!data) {
      throw new Error(
        "Couldn't draw chart because coordinates data is missing"
      );
    }
    const dataObj = JSON.parse(data);

    return dataObj.map(({ coord_x, coord_y }) => ({
      x: coord_x,
      y: coord_y,
    }));
  }

  renderChart() {
    if ("line" === this.type) {
      this.coordinates = this.collectCoordinates(this.chartRoot.dataset.coords);
      this.renderLineChart();
    }
  }

  renderLineChart() {
    new Chart(this.canvas, {
      type: this.type,
      data: {
        datasets: [
          {
            label: this.chartRoot.dataset.title,
            data: this.coordinates,
            fill: true,
            borderColor: "#d93834",
            backgroundColor: this.gradient,
            tension: 0,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            type: "linear",
            title: {
              display: true,
              text: this.chartRoot.dataset.xLabel,
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: this.chartRoot.dataset.yLabel,
            },
          },
        },
      },
    });
  }
}
export default TouchitChart;

document.addEventListener("DOMContentLoaded", () => {
  // Generate charts, if applicable
  const charts = document.getElementsByClassName('touchit-chart-canvas')

  for (let canvas of charts) {
    try {
      new TouchitChart(canvas);
    } catch (e) {
      console.error(e.message);
    }
  }
});